import Text from '@/components/custom-ui/text'
import Image from 'next/image'
import React from 'react'
import { EligibilitySection } from '@/lib/api/strapi/eligibility-section/eligibility-section.types'
import { Dictionary } from '@/localization/dictionary'
type OfferCardProps = {
  points: number
  eligibilitySection?: EligibilitySection | null
  label?: string
  iconSrc?: string
  pointsText: string
  dict: Dictionary['shoppingBag']
}

export default function OfferCard({
  points,
  eligibilitySection,
  label,
  iconSrc,
  pointsText,
  dict,
}: OfferCardProps) {
  return (
    <div className="flex w-full flex-col items-center gap-4 bg-gray-100 px-3 py-1 shadow-md sm:flex-row">
      <div className="flex min-w-20 flex-row items-center justify-center gap-4 text-center text-[8px] font-normal text-primary-600 sm:flex-col sm:gap-0 sm:text-2xs sm:font-medium">
        <span>{dict.hostOffer.youEarnedIt}</span>
        <div className="flex items-center justify-center gap-2">
          <Image
            priority
            src={iconSrc || '/icons/star.svg'}
            height={24}
            width={24}
            alt={'points'}
            className={`size-6`}
          />
          <span className="text-xl font-bold">{points}</span>
        </div>
        <span>{label || pointsText}</span>
      </div>

      <div className="flex flex-1 flex-col justify-center gap-1">
        <Text className="text-2xs font-semibold uppercase">
          {eligibilitySection?.info_title}
        </Text>
        <div className="h-[1px] w-full bg-gray-300" />
        <p className="text-[8px] leading-3 text-black">
          {eligibilitySection?.info_description}
        </p>
      </div>
    </div>
  )
}
